import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, Optional } from '@angular/core';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { IProductDataV2 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { Subscription } from 'rxjs';
import { NModalLayout } from '../../common/modal/layout/modal-layout.component';
import { Product } from '../product/product.decorator';

export namespace NProductListingFiltersModal {
    /**
     * Modal identifier
     */
    export const id = 'product-listing-filters';

    /**
     * Datapasset to modal
     */
    export interface IModalData {
        listing: ProductListing<Product<IProductDataV2>>;
        openSort?: boolean;
    }
}

@DfModal({
    id: NProductListingFiltersModal.id,
    position: 'bottom',
    config: NModalLayout.Bottom.modalConfig({
        modalClass: 'p-a-0',
        maxHeight: '78vh',
        minHeight: '50vh'
    }),
    sizeRestriction: sizeId => ({ S: ['S'], M: ['M'] })[sizeId],
    reopenPolicy: NDfModal.ReopenPolicy.first
})
@Component({
    templateUrl: './product-listing-filters.modal.html',
    // styleUrls: ['./filter-modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingFiltersModalComponent implements NDfModal.IModalComponent, OnInit {
    /**
     * Modal option config
     */
    modalConfig?: NDfModal.IModalConfig;

    /**
     * Listing changes subscription
     */
    private listingSubscription?: Subscription;

    /**
     * Listing shorthand
     */
    get listing() {
        return this.data.listing;
    }

    constructor(
        readonly client: Client,
        private app: App,
        private changeDetectorRef: ChangeDetectorRef,
        @Optional() private modalRef: ModalRef<any>,
        @Optional() @Inject(MODAL_DATA) protected data: NProductListingFiltersModal.IModalData
    ) {
        this.changeDetectorRef.detach();
        modalRef.afterClosed().subscribe(() => {
            this.listingSubscription?.unsubscribe();
        });
    }

    /**
     * Initiate component
     */
    ngOnInit() {
        this.listingSubscription = this.listing.subscribe(() => this.detectChanges());
        this.detectChanges();
    }

    /**
     * Close modal
     */
    close() {
        this.modalRef.close();
    }

    /**
     * Change detection
     */
    private detectChanges() {
        this.changeDetectorRef.detectChanges();
    }
}
